<template>
    <navbar />
    <!-- partial -->
    <div class="container-fluid page-body-wrapper">
      <sidebar />
      <div class="main-panel">
        <div class="content-wrapper">
          <div class="row">
            <div class="col-lg-12 px-0">
              <div class="card">
                <div class="card-body">
                  <div class="row col-md-9 mb-4">
                      <div class="d-flex flex-wrap gap-3">
                          <button class="btn text-white py-2 px-4" style="background-color: #007bff; border-radius: 6%;" data-bs-toggle="modal" data-bs-target="#addModal">Add New Ward</button>
                      </div>
                  </div>
                  <div class="row mb-3 align-items-center">
                    <div class="col-md-2">
                      <input type="text" class="form-control form-control-sm" v-model="searchForm.name" placeholder="Ward No">
                    </div>
                    <div class="col-md-2">
                        <select class="form-control form-control-sm" v-model="searchForm.status">
                            <option value="" disabled>-- Select --</option>
                            <option value="active">Active</option>
                            <option value="inactive">InActive</option>
                        </select>
                    </div>
                    <div class="col-md-1">
                      <button class="btn btn-success btn-block btn-sm text-white" style="border-radius: 6%;" @click="searchWard()">Search</button>
                    </div>
                    <div class="col-md-1">
                      <button class="btn btn-danger btn-block btn-sm text-white" style="border-radius: 6%;" @click="resetWard()">Reset</button>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-striped table-borderless">
                      <thead style="border-top: 1px solid grey; border-bottom: 1px solid grey;">
                        <tr>
                          <th>SL No.</th>
                          <th>Ward No</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="wardList != null">
                        <tr v-for="(data, index) in wardList" :key="index">
                          <td>{{(pagination.current_page*10)-10 + index+1}}</td>
                          <td class="font-weight-bold">{{ data.name }}</td>
                          <td>
                            <span class="badge badge-success" v-if="data.status == 'active'">Active</span>
                            <span class="badge badge-danger"  v-else>InActive</span>
                          </td>
                          <td>
                              <div class="dropdown">
                              <a href="#" class="text-dark" data-bs-toggle="dropdown" aria-expanded="false">
                                  <i class="fa-solid fa-gear fa-lg" style="color: #63452c;"></i>                            </a>
                                  <ul class="dropdown-menu">
                                      <li><button class="dropdown-item" data-bs-toggle="modal" :data-bs-target="'#edit-ward'+index" @click="editWard(data.id)">Edit</button></li>
                                  </ul>
                              </div>
                               <!-- Edit Citizen modal -->
                              <div class="modal fade" :id="'edit-ward'+index" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                  <div class="modal-dialog custom-md-model"> <!-- Apply the custom class here -->
                                      <div class="modal-content">
                                      
                                      <!-- Modal Header -->
                                      <div class="modal-header">
                                          <h5 class="modal-title" id="exampleModalLabel">Edit Ward</h5>
                                          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                      </div>
                                      <!-- Modal Body -->
                                      <div class="modal-body px-4">
                                        <div class="row">
                                            <div class="col-md-6 form-group mb-3">
                                            <label class="form-label fw-bold">Ward:</label>
                                            <input type="text" class="form-control form-control-sm" v-model="editForm.name"> 
                                            </div>
                                            <div class="col-md-6 form-group mb-3">
                                            <label class="form-label fw-bold">Status:</label>
                                            <select class="form-control form-control-sm" v-model="editForm.status">
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                            </div>
                                        </div>
                                      </div>
                                      <!-- Modal Footer -->
                                      <div class="modal-footer">
                                        <button type="button" class="btn btn-danger text-white py-2" data-bs-dismiss="modal" style="border-radius: 6%;">Cancel</button>
                                        <button type="submit" class="btn btn-success text-white py-2" style="border-radius: 6%;" @click="updateWard(data.id)">Update</button>
                                      </div>
                                      </div>
                                  </div>
                              </div>
                          </td>
  
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="13" style="text-align: center; font-size: 18px;color: #de0723;">No Data Found !</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="p-2" v-if="this.searchPagination == false">
                        <pagination v-if="pagination.last_page > 1" 
                        :pagination="pagination" 
                        :offset="10" 
                        @paginate="getWards()">
                        </pagination>
                    </div>
                    <div v-else>
                        <pagination v-if="pagination.last_page > 1" 
                        :pagination="pagination" 
                        :offset="10" 
                        @paginate="searchWard()">
                        </pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="footer">
          <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2023. Premium <a href="" target="_blank"></a> All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"></span>
          </div>
        </footer>
      </div>
  
      <!-- Add New Ward modal -->
      <div class="modal fade" id="addModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog custom-md-model">
            <form class="form" @submit.prevent="addWard()">
              <div class="modal-content">
              
              <!-- Modal Header -->
              <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">New Ward</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              
              <!-- Modal Body -->
              <div class="modal-body px-4">
                  <div class="row">
                    <div class="col-md-6 form-group mb-3">
                      <label class="form-label fw-bold">Ward:</label>
                      <input type="text" class="form-control form-control-sm" v-model="addForm.name"> 
                    </div>
                    <div class="col-md-6 form-group mb-3">
                      <label class="form-label fw-bold">Status:</label>
                      <select class="form-control form-control-sm" v-model="addForm.status">
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
              </div>
              <!-- Modal Footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-danger text-white py-2" data-bs-dismiss="modal" style="border-radius: 6%;">Cancel</button>
                <button type="submit" class="btn btn-success text-white py-2" style="border-radius: 6%;">Save</button>
              </div>
              
              </div>
            </form>
          </div>
      </div>
      <!-- main-panel ends -->
    </div>
  </template>
  <script>
    import Navbar   from '../layouts/navbar.vue';
    import Sidebar  from '../layouts/sidebar.vue';
    import Api      from '../util/Api';
    import Chokidar from '../util/Chokidar';
    import Pagination   from '../util/Pagination.vue'
  
    export default {
      components: {
        navbar: Navbar,
        sidebar: Sidebar,
        pagination: Pagination
      },
      data() {
        return {
  
          isLoading : false,
  
          addForm:{
            name   : '',
            status : ''
          },
          editForm:{
            name   : '',
            status : ''
          },
  
          wardList : [{}],
  
          pagination: {
            current_page: 1,
          },
  
          searchPagination : false,
  
          searchForm:{
            name   : '',
            status : ''
          }
  
        }
      },
  
      methods:{
        getWards(){
          this.searchPagination = false;
          Api().get('/get-ward-data/?page='+this.pagination.current_page)
          .catch((error) => {
            if (error.response.status == 401) {
              localStorage.removeItem('token');
              localStorage.removeItem('guard');
              this.$swal({
                icon: 'error',
                title: 'Session Expired, please login!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000
              });
              this.$router.push('/login');
            } 
          }).then(response =>{
            this.wardList    = response.data.data;
            this.pagination  = response.data.meta;
          });
        },
  
        addWard()
        {
          Api().post('/add-ward',this.addForm)
            .catch((error) => {
              if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                  icon: 'error',
                  title: 'Session Expired, please login!',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
                this.$router.push('/login');
              } 
            }).then(response =>{
              if(response.data['success'] == true)
              {
                this.getWards();
                $('#addModal').modal('hide');
                this.$swal({
                    icon: 'success',
                    title: ' '+response.data['message'],
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000
                });
              }
            });
        },
  
        editWard(id)
        {
              Api().get('/edit-ward/'+id)
              .catch((error) => {
                          if (error.response.status == 401) {
                              localStorage.removeItem('token');
                              localStorage.removeItem('guard');
                              this.$swal({
                              icon: 'error',
                              title: 'Session Expired please login!',
                              toast: true,
                              position: 'top-end',
                              showConfirmButton: false,
                              timer: 4000
                              });
                              this.$router.push('/admin/login');
                          } 
                  }).then((response) => {
                    this.editForm ={
                        name   : response.data.name,
                        status : response.data.status
                    }
             });
        },
  
        updateWard(id,index)
        {
            Api().post('/update-ward/'+id,this.editForm)
            .catch((error) => {
              if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                  icon: 'error',
                  title: 'Session Expired, please login!',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
                this.$router.push('/login');
              } 
            }).then(response =>{
              if(response.data['success'] == true)
              {
                this.getWards();
               
                $('#edit-ward'+index).modal('hide');
                this.$swal({
                    icon: 'success',
                    title: ' '+response.data['message'],
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000
                });
              }
            });
        },

        searchWard()
        {
            this.searchPagination = true;
            Api().post('/search-ward?page='+this.pagination.current_page,this.searchForm)
            .catch((error) => {
              if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                  icon: 'error',
                  title: 'Session Expired, please login!',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
                this.$router.push('/login');
              } 
            }).then(response =>{
              console.log(response)
                this.isLoading = false;
                this.wardList    = response.data.data;
                this.pagination  = response.data.meta;
            });
        },
  
        resetWard(){
          this.searchForm={
            name   : '',
            status : ''
          },
          this.getWards();
        }
      },
      created()
      {
        if(Chokidar() != 'user'){
          this.$router.push('/login');
        }else{
          this.getWards();
        }
      }
    }
  </script>